import {combineReducers, createReducer} from 'redux-immutablejs';
import {reducer as formReducer} from 'redux-form/immutable';
import {reducer as notifyReducer} from 'common/notify/immutable';

import appReducer from './appReducer';
import cardReducer from './cardReducer';
import bookReducer from './bookReducer';
import reviewReducer from './reviewReducer';
import socketReducer from './socketReducer';

export default combineReducers({
	form: formReducer,
	notifications: createReducer(notifyReducer.initialState, notifyReducer.actionHandlers),
	app: appReducer(createReducer),
	card: cardReducer(createReducer),
	book: bookReducer(createReducer),
	review: reviewReducer(createReducer),
	socket: socketReducer(createReducer),
});



// WEBPACK FOOTER //
// ./src/reducers/index.js